import {
    reduxActions,
    fetchTypes,
    requestStatus
} from '../constants';

const defaultState = {
    currentPageNumber: 1,
    pageSize: 20,
    results: [],
    totalItemCount: 0,
    totalPageCount: 0,
    status: requestStatus.INACTIVE,
    removedUserId: null,
    removedUserRole: ''
}

export function userApprovalQueue(state = defaultState, action) {
    if (action.fetchType === fetchTypes.APPROVAL_QUEUE) {
        switch (action.type) {
            case reduxActions.RESOURCE_FETCH:
                return Object.assign({}, state, {
                    status: action.status,
                    error: false,
                    progress: action.progress
                });
            case reduxActions.RESOURCE_FETCH_FAIL:
                return Object.assign({}, state, {
                    status: action.status,
                    error: action.error,
                    progress: action.progress
                })
            case reduxActions.RESOURCE_FETCH_SUCCESS:
                return Object.assign({}, state, action.payload, {
                    status: action.status,
                    error: false,
                    progress: action.progress,
                    results: action.payload.results.map(item => {
                        return Object.assign({}, item, {
                            approve: false
                        });
                    })
                });
        }
    }
    
    if (action.fetchType === fetchTypes.USER_APPROVE) {
        let results;
        switch (action.type) {
            case reduxActions.RESOURCE_RESET:
                return Object.assign({}, state, {
                    removedUserId: 0,
                    removedUserRole: ''
                });
            case reduxActions.RESOURCE_FETCH_SUCCESS:
                results = state.results.filter(user => {
                    return user.userId !== action.request.payload.userId
                });

                console.log('updating state');
                return Object.assign({}, state, {
                    results: results,
                    removedUserId: action.request.payload.userId,
                    removedUserRole: action.request.payload.role
                });
        }
    }

    if (action.fetchType === fetchTypes.USER_REJECT) {
        let results;
        switch (action.type) {
            case reduxActions.RESOURCE_FETCH_SUCCESS:
                results = state.results.filter(user => {
                    return user.userId !== action.request.payload.userId
                });
                return Object.assign({}, state, {
                    results: results
                });
        }
    }

    return state;
}

export function adminUserList(state = defaultState, action) {
    if (action.fetchType === fetchTypes.USER_SEARCH) {
        switch (action.type) {
            case reduxActions.RESOURCE_FETCH:
                return Object.assign({}, state, {
                    status: action.status,
                    error: false,
                    progress: action.progress
                });
            case reduxActions.RESOURCE_FETCH_FAIL:
                return Object.assign({}, state, {
                    status: action.status,
                    error: action.error,
                    progress: action.progress
                });
            case reduxActions.RESOURCE_FETCH_SUCCESS:
                return Object.assign({}, state, action.payload, {
                    status: action.status,
                    error: false,
                    progress: action.progress
                });
        }
    }

    if (action.fetchType === fetchTypes.USER_REVOKE_ACCESS) {
        switch (action.type) {
            case reduxActions.RESOURCE_FETCH_SUCCESS:
                return Object.assign({}, state, {
                    results: state.results.filter(user => {
                        return user.userId !== action.request.payload.userId;
                    })
                });
        }
    }

    return state;
}

export function adminRevokedUserList(state = defaultState, action) {
    if (action.fetchType === fetchTypes.USER_REVOKED_SEARCH) {
        switch (action.type) {
            case reduxActions.RESOURCE_FETCH:
                return Object.assign({}, state, {
                    status: action.status,
                    error: false,
                    progress: action.progress
                });
            case reduxActions.RESOURCE_FETCH_FAIL:
                return Object.assign({}, state, {
                    status: action.status,
                    error: action.error,
                    progress: action.progress
                });
            case reduxActions.RESOURCE_FETCH_SUCCESS:
                return Object.assign({}, state, action.payload, {
                    status: action.status,
                    error: false,
                    progress: action.progress
                });
        }
    }

    if (action.fetchType === fetchTypes.USER_RESTORE_ACCESS) {
        switch (action.type) {
            case reduxActions.RESOURCE_FETCH_SUCCESS:
                return Object.assign({}, state, {
                    results: state.results.filter(user => {
                        return user.userId !== action.request.payload.userId;
                    })
                });
        }
    }

    return state;
}

export function adminTabState(state = 'PENDING', action) {
    switch (action.type) {
        case reduxActions.USER_MANAGEMENT_SET_TAB_STATE:
            return action.state;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./web-app/reducers/user-management-reducer.js